import icons from './utils/icons'
import storage from '../../store/storage'

const { VUE_APP_VERSION } = process.env

const STORAGE_KEY_NAV_COLLAPSED = 'navCollapsed'
const drawerState = storage.getDrawerState(STORAGE_KEY_NAV_COLLAPSED)
const navCollapsed = storage.getNavCollapsedState(drawerState)

// Initialize darkMode to match OS preference, same as Vuetify does
// This keeps theme state in sync from app startup
const resolveInitialDarkMode = () => {
  try {
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false
  } catch (e) { return false }
}

const initialDarkMode = resolveInitialDarkMode()

const state = () => ({
  version: VUE_APP_VERSION,
  promptError: false,
  promptRefresh: false,
  serviceWorkerRegistration: null,

  params: null,
  currentRoute: {},

  drawerState,
  navCollapsed,
  STORAGE_KEY_NAV_COLLAPSED,

  darkMode: initialDarkMode,
  isSettingsModalVisible: false,

  icons,
})

export default state
